/**
 * 学术交流
 */

import Container from '@/containers';

const xsjlRouter = {
    path: '/xsjl',
    component: Container,
    redirect: '/xsjl/index',
    name: 'XueShuJiaoLiu',
    meta: {
        title: '学术交流'
    },
    children: [
        {
            path: 'index',
            component: () => import('@/views/xsjl'),
            name: 'XueShuJiaoLiu',
            meta: {
                title: '学术交流',
                index:1
            }
        },
        {
            path: 'zyxs',
            component: () => import('@/views/xsjl/zyxs'),
            name: 'ZhongYaoXueShuHuiYi',
            meta: {
                title: '中国科协重要学术会议指南',
                subTitle:'学术交流',
                returnLink:'/xsjl'
            }
        }
    ]
};

export default xsjlRouter;